//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteOcrAccountsService } from "@/features/accounts/ocr/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useDeleteOcrAccountStates } from "@/features/accounts/ocr/hooks/use-delete-accounts-states";
import { useContext } from "react";


export const useDeleteOcrAccounts = () => {
  const {
    ocrAccountId,
    setOcrAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useDeleteOcrAccountStates();
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteOcrAccountsService = new DeleteOcrAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // OCR口座削除
  const deleteOcrAccounts = async (
    accountGroupId: string,
    ocrAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteOcrAccountsService.deleteOcrAccounts({
        account_group_id: accountGroupId,
        ocr_account_id: ocrAccountId,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deleteOcrAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    ocrAccountId,
    setOcrAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
    deleteOcrAccounts: errorHandledAsync(deleteOcrAccounts, setError),
  };
};
